import withRequiresAuth from './withRequiresAuth';

export default withRequiresAuth;
